module.exports = __webpack_public_path__ + "img/location-minus.92d3144c.svg";